var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalGeneratedSampleShops(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 125,
    viewBox: "0 0 145 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M124.801 10H19.9014V115H124.801V10Z",
    fill: "#003393"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M108.872 19.8033H35.6865V105.34H108.872V19.8033Z",
    fill: "#003393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.559 25.0821H95.3828V100.492H134.559V25.0821Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1758 25.3694H10V100.78H49.1758V25.3694Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.268 26.2312H96.6748V98.9125H133.268V26.2312Z",
    fill: "#003393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.291 98.9125H47.8838L47.8838 26.2312H11.291L11.291 98.9125Z",
    fill: "#003393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.857 32.8386H17.3184V37.2914H41.857V32.8386Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.383 39.5896H102.845V44.0424H127.383V39.5896Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.24 46.4843H102.701V50.9371H127.24V46.4843Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.24 53.3789H102.701V57.8317H127.24V53.3789Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.24 60.2736H102.701V64.7264H127.24V60.2736Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.24 67.1683H102.701V71.6211H127.24V67.1683Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.24 74.0629H102.701V78.5157H127.24V74.0629Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.24 80.9576H102.701V85.4104H127.24V80.9576Z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.24 87.8522H102.701V92.305H127.24V87.8522Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.24 32.8386H102.701V37.2914H127.24V32.8386Z",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.857 39.8769H17.3184V44.3297H41.857V39.8769Z",
    fill: "url(#paint12_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.857 46.6279H17.3184V51.0807H41.857V46.6279Z",
    fill: "url(#paint13_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.857 53.3789H17.3184V57.8317H41.857V53.3789Z",
    fill: "url(#paint14_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.857 60.2736H17.3184V64.7264H41.857V60.2736Z",
    fill: "url(#paint15_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.857 67.1683H17.3184V71.6211H41.857V67.1683Z",
    fill: "url(#paint16_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4267 33.4131H17.8926V36.8605H41.4267V33.4131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3554 40.1642H17.8213V43.6115H41.3554V40.1642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3554 47.0588H17.8213V50.5062H41.3554V47.0588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3554 53.9535H17.8213V57.4008H41.3554V53.9535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3554 60.8481H17.8213V64.2955H41.3554V60.8481Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3554 67.7428H17.8213V71.1901H41.3554V67.7428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.857 74.0629H17.3184V78.5157H41.857V74.0629Z",
    fill: "url(#paint17_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3554 74.6375H17.8213V78.0848H41.3554V74.6375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3554 74.6375H17.8213V78.0848H41.3554V74.6375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3554 81.5322H17.8213V84.9795H41.3554V81.5322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3554 88.4268H17.8213V91.8742H41.3554V88.4268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.81 33.2695H103.275V36.7168H126.81V33.2695Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.81 40.1642H103.275V43.6115H126.81V40.1642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.81 47.0588H103.275V50.5062H126.81V47.0588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.81 53.9535H103.275V57.4008H126.81V53.9535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.81 60.8481H103.275V64.2955H126.81V60.8481Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.81 67.7428H103.275V71.1901H126.81V67.7428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.81 74.6375H103.275V78.0848H126.81V74.6375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.81 81.5322H103.275V84.9795H126.81V81.5322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.81 88.4268H103.275V91.8742H126.81V88.4268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.473 102.647H28.9424V108.105H115.473V102.647Z",
    fill: "url(#paint18_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.899 103.222H29.6592V107.531H114.899V103.222Z",
    fill: "#003393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.617 17.1819H29.2295V22.7839H115.617V17.1819Z",
    fill: "url(#paint19_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.899 17.6129H29.6592V21.922H114.899V17.6129Z",
    fill: "#003393"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M93.374 26.2312H51.4717V98.9125H93.374V26.2312Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.662 57.8389C105.667 59.1862 104.163 60.7778 104.163 60.7778L104.415 60.8654C104.044 61.2776 102.576 63.1377 96.916 71.5521C89.6692 82.325 79.904 85.0125 79.904 85.0125C78.7174 84.0846 77.3677 83.3874 75.9247 82.957V81.9401C77.7686 81.3957 79.4534 80.4127 80.8353 79.075C82.2172 77.7373 83.2551 76.0847 83.8603 74.2583C84.7243 72.5463 85.1736 70.6548 85.1719 68.7368C85.1719 61.8421 79.4649 56.2488 72.4261 56.2488C65.3874 56.2488 59.6804 61.8407 59.6804 68.7368C59.6787 70.6548 60.128 72.5463 60.992 74.2583C61.5972 76.0847 62.6351 77.7373 64.017 79.075C65.3989 80.4127 67.0837 81.3957 68.9276 81.9401V82.957C67.4845 83.3874 66.1348 84.0846 64.9483 85.0125C64.9483 85.0125 55.1788 82.3221 47.932 71.5492C42.2723 63.1349 40.8043 61.2733 40.4326 60.8625L40.6852 60.7749C40.6852 60.7749 39.1856 59.1834 40.1858 57.836C41.186 56.4887 33.5632 54.8972 34.4371 57.836C35.3111 60.7749 36.4361 62.2443 36.4361 62.2443C36.4361 62.2443 52.3934 87.4357 60.7236 91.5984C60.5268 92.4519 60.4277 93.3251 60.428 94.2011V99.0992H84.4185V94.2011C84.4189 93.3251 84.3197 92.4519 84.1229 91.5984C92.446 87.4328 108.41 62.2457 108.41 62.2457C108.41 62.2457 109.535 60.7763 110.409 57.8375C111.283 54.8986 103.662 56.4916 104.662 57.8389Z",
    fill: "url(#paint20_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.423 81.6083C79.1643 81.6083 84.6292 76.1381 84.6292 69.3903C84.6292 62.6426 79.1643 57.1724 72.423 57.1724C65.6817 57.1724 60.2168 62.6426 60.2168 69.3903C60.2168 76.1381 65.6817 81.6083 72.423 81.6083Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4233 82.8077C78.7683 82.8077 83.9119 77.6591 83.9119 71.308C83.9119 64.9568 78.7683 59.8082 72.4233 59.8082C66.0782 59.8082 60.9346 64.9568 60.9346 71.308C60.9346 77.6591 66.0782 82.8077 72.4233 82.8077Z",
    fill: "#F8C198"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8749 70.2292C68.6683 70.2292 69.3114 69.5855 69.3114 68.7914C69.3114 67.9973 68.6683 67.3536 67.8749 67.3536C67.0816 67.3536 66.4385 67.9973 66.4385 68.7914C66.4385 69.5855 67.0816 70.2292 67.8749 70.2292Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2099 70.2292C78.0032 70.2292 78.6463 69.5855 78.6463 68.7914C78.6463 67.9973 78.0032 67.3536 77.2099 67.3536C76.4166 67.3536 75.7734 67.9973 75.7734 68.7914C75.7734 69.5855 76.4166 70.2292 77.2099 70.2292Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7737 76.5766C75.7737 77.4384 74.2742 78.8532 72.423 78.8532C70.5718 78.8532 69.0723 77.4384 69.0723 76.5766C69.0723 75.7148 70.5718 75.7377 72.423 75.7377C74.2742 75.7377 75.7737 75.7148 75.7737 76.5766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2342 69.2712C68.4989 69.2712 68.7135 69.0564 68.7135 68.7914C68.7135 68.5264 68.4989 68.3116 68.2342 68.3116C67.9695 68.3116 67.7549 68.5264 67.7549 68.7914C67.7549 69.0564 67.9695 69.2712 68.2342 69.2712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6883 69.2712C77.953 69.2712 78.1676 69.0564 78.1676 68.7914C78.1676 68.5264 77.953 68.3116 77.6883 68.3116C77.4236 68.3116 77.209 68.5264 77.209 68.7914C77.209 69.0564 77.4236 69.2712 77.6883 69.2712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5708 64.9246C72.8705 64.9246 72.242 64.3156 72.1674 63.6189C72.1431 63.2687 72.2264 62.9194 72.4059 62.6178C72.5854 62.3162 72.8526 62.0766 73.1719 61.9312C73.2372 61.8974 73.3093 61.8787 73.3828 61.8766C73.6239 61.8766 73.743 62.1639 73.8205 62.3922C74.0616 63.0989 74.4892 63.7884 75.1608 64.1159C75.8324 64.4434 76.7709 64.2753 77.1253 63.6175C76.1753 63.1937 75.7692 61.8637 76.3217 60.9817C76.5355 60.6413 76.8684 60.3526 76.9359 59.9561C77.0593 59.2379 76.2729 58.7151 75.5769 58.4996C73.5679 57.8777 66.5651 57.8087 66.1791 60.8093C65.7744 63.9751 71.3652 65.344 73.5708 64.9246Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.158 73.3253C62.5267 73.1797 62.4911 72.2135 62.0787 71.1671C61.6663 70.1206 61.0331 69.3904 60.6645 69.5359C60.2959 69.6815 60.3314 70.6478 60.7438 71.6942C61.1563 72.7406 61.7894 73.4709 62.158 73.3253Z",
    fill: "#F8C198"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0992 71.6866C84.5116 70.6402 84.5472 69.6739 84.1785 69.5284C83.8099 69.3828 83.1768 70.1131 82.7643 71.1595C82.3519 72.2059 82.3164 73.1721 82.685 73.3177C83.0536 73.4633 83.6868 72.733 84.0992 71.6866Z",
    fill: "#F8C198"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5849 85.3156C79.5849 85.3156 88.9368 82.687 95.878 72.1453C102.819 61.6037 103.178 61.575 103.178 61.575L106.887 63.0415C106.887 63.0415 89.6558 90.8328 82.2368 92.2706C74.8178 93.7084 79.5849 85.3156 79.5849 85.3156Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.82 61.6051C102.82 61.6051 104.255 60.0481 103.3 58.7323C102.344 57.4166 109.642 55.8596 108.804 58.7323C107.966 61.6051 106.89 63.0415 106.89 63.0415L102.82 61.6051Z",
    fill: "#F8C198"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2605 85.3156C65.2605 85.3156 55.9085 82.687 48.9674 72.1453C42.0263 61.6037 41.6675 61.575 41.6675 61.575L37.958 63.0415C37.958 63.0415 55.191 90.8328 62.6115 92.2706C70.0319 93.7084 65.2605 85.3156 65.2605 85.3156Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0248 61.6051C42.0248 61.6051 40.5898 60.0481 41.5455 58.7323C42.5012 57.4166 35.2028 55.8596 36.0408 58.7323C36.8788 61.6051 37.9551 63.0415 37.9551 63.0415L42.0248 61.6051Z",
    fill: "#F8C198"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M76.3384 59.2351C76.2696 59.6315 75.9366 59.9188 75.7243 60.2607C75.2407 61.0335 75.4918 62.151 76.2007 62.7025C76.0988 62.444 76.0568 62.1656 76.0779 61.8884C76.099 61.6113 76.1827 61.3425 76.3227 61.1024C76.5365 60.762 76.8694 60.4733 76.9368 60.0768C77.0143 59.6272 76.7345 59.2538 76.3442 58.9852C76.3544 59.0683 76.3525 59.1525 76.3384 59.2351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M73.3499 61.9987C73.304 61.891 73.261 61.7818 73.2236 61.6726C73.1462 61.4443 73.0271 61.1642 72.786 61.157C72.7125 61.1591 72.6404 61.1778 72.575 61.2116C72.2558 61.357 71.9885 61.5966 71.809 61.8982C71.6295 62.1998 71.5463 62.5491 71.5705 62.8993C71.5972 63.1106 71.6681 63.3138 71.7786 63.4958C71.8892 63.6777 72.0368 63.8342 72.212 63.9551C72.1917 63.8841 72.1773 63.8115 72.1689 63.7382C72.1447 63.3879 72.2279 63.0386 72.4074 62.737C72.5869 62.4354 72.8542 62.1959 73.1734 62.0504C73.229 62.0235 73.2886 62.006 73.3499 61.9987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M72.3377 64.2739C70.5928 64.3472 67.7773 63.6807 66.3896 62.263C67.4257 64.4693 71.7064 65.3929 73.5647 65.0381C73.3112 65.0296 73.0644 64.9545 72.8491 64.8204C72.6337 64.6862 72.4574 64.4978 72.3377 64.2739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M76.3948 63.0904C75.9757 63.5831 75.1635 63.6865 74.5651 63.3949C74.3697 63.2985 74.1905 63.172 74.0342 63.02C74.2661 63.5382 74.6633 63.9646 75.1635 64.2323C75.8351 64.5584 76.7736 64.3918 77.128 63.7339C76.8262 63.5955 76.5714 63.3718 76.3948 63.0904Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M106.411 63.0415C106.411 63.0415 89.1784 90.8328 81.7508 92.2706C81.3216 92.3566 80.8865 92.4099 80.4492 92.4301C81.047 92.4471 81.6448 92.3936 82.2301 92.2706C89.6505 90.8342 106.884 63.0415 106.884 63.0415L106.499 62.9051C106.446 62.9956 106.411 63.0415 106.411 63.0415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M38.435 63.0415C38.435 63.0415 55.668 90.8328 63.0956 92.2706C63.5248 92.3566 63.9599 92.4099 64.3972 92.4301C63.7994 92.4471 63.2016 92.3936 62.6163 92.2706C55.1959 90.8342 37.9629 63.0415 37.9629 63.0415L38.3475 62.9051C38.4006 62.9956 38.435 63.0415 38.435 63.0415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4233 82.8077C73.932 82.8077 75.4259 83.1051 76.8198 83.683C78.2137 84.261 79.4802 85.108 80.547 86.1759C81.6138 87.2437 82.4601 88.5114 83.0374 89.9067C83.6148 91.3019 83.9119 92.7972 83.9119 94.3074V99.0992H60.9346V94.3074C60.9346 92.7972 61.2317 91.3019 61.8091 89.9067C62.3865 88.5114 63.2327 87.2437 64.2995 86.1759C65.3664 85.108 66.6329 84.261 68.0267 83.683C69.4206 83.1051 70.9145 82.8077 72.4233 82.8077Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M72.5423 82.868C72.1243 82.8679 71.7066 82.8905 71.291 82.9355C71.4345 82.9355 71.5651 82.9269 71.7043 82.9269C74.7513 82.9269 77.6735 84.1385 79.828 86.2951C81.9826 88.4517 83.193 91.3767 83.193 94.4266V99.1581H84.031V94.3677C84.031 91.3178 82.8206 88.3928 80.6661 86.2362C78.5115 84.0796 75.5893 82.868 72.5423 82.868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M72.3041 82.868C72.7221 82.8679 73.1399 82.8905 73.5555 82.9355C73.412 82.9355 73.2814 82.9269 73.1422 82.9269C70.0952 82.9269 67.173 84.1385 65.0184 86.2951C62.8639 88.4517 61.6535 91.3767 61.6535 94.4266V99.1581H60.8154V94.3677C60.8154 91.3178 62.0258 88.3928 64.1804 86.2362C66.3349 84.0796 69.2571 82.868 72.3041 82.868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7738 82.9872C75.7738 81.1349 74.2736 79.6332 72.423 79.6332C70.5724 79.6332 69.0723 81.1349 69.0723 82.9872V84.3647C69.0723 86.217 70.5724 87.7187 72.423 87.7187C74.2736 87.7187 75.7738 86.217 75.7738 84.3647V82.9872Z",
    fill: "#F8C198"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 144.559,
    height: 125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.722396 0 0 0 0 0.788519 0 0 0 0 0.9125 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 114.971,
    y1: 100.492,
    x2: 114.971,
    y2: 25.0821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 5357.49,
    y1: 47684.7,
    x2: 5357.49,
    y2: 8094.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 29.5877,
    y1: 37.2914,
    x2: 29.5877,
    y2: 32.8386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 18077.4,
    y1: 1094.9,
    x2: 18077.4,
    y2: 956.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 18052.7,
    y1: 1315.53,
    x2: 18052.7,
    y2: 1177.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 18052.7,
    y1: 1536.16,
    x2: 18052.7,
    y2: 1398.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 18052.7,
    y1: 1756.79,
    x2: 18052.7,
    y2: 1618.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 18052.7,
    y1: 1977.42,
    x2: 18052.7,
    y2: 1839.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 18052.7,
    y1: 2198.04,
    x2: 18052.7,
    y2: 2060.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 18052.7,
    y1: 2418.68,
    x2: 18052.7,
    y2: 2280.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 18052.7,
    y1: 2639.31,
    x2: 18052.7,
    y2: 2501.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 18052.7,
    y1: 32.8386,
    x2: 18052.7,
    y2: 32.8386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 1268.79,
    y1: 1035.08,
    x2: 5464.9,
    y2: 1035.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 1268.79,
    y1: 1251.11,
    x2: 5464.9,
    y2: 1251.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 1268.79,
    y1: 1467.15,
    x2: 5464.9,
    y2: 1467.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 1268.79,
    y1: 1687.77,
    x2: 5464.9,
    y2: 1687.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 1268.79,
    y1: 1908.4,
    x2: 5464.9,
    y2: 1908.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 1268.79,
    y1: 2129.03,
    x2: 5464.9,
    y2: 2129.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 11451,
    y1: 3726.94,
    x2: 63629.3,
    y2: 3726.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 37607.8,
    y1: 515.752,
    x2: 37607.8,
    y2: 297.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 45777.8,
    y1: 30308,
    x2: 45777.8,
    y2: 17482.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalGeneratedSampleShops);
export default __webpack_public_path__ + "static/media/modal_generated_sample_shops.49d746e9ffc5d192affce45452ee6111.svg";
export { ForwardRef as ReactComponent };